import { Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';
@Pipe({name: 'isSelected'})
export class IsSelected implements PipeTransform {
  transform(items: any[], attribToCheck: string): Observable<boolean> {
    return new Observable<boolean>(obs => obs.next(items.some(ele => ele[attribToCheck] === true)))
  }
}